import api from '../clients/api';
import { handleUnauthorized } from '../utils/apiWrapper';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
  getImageBase64,
};

function getImageBase64(imageUrl: string) {
  notifyBugsnagNetwork('image', 'getImageBase64', { imageUrl });
  return handleUnauthorized(() => api.lernsets.getImageBase64(imageUrl));
}

export default service;

